/* eslint-disable react/prop-types */
import dayjs from "dayjs";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import StatusChip from "components/common/StatusChip";
import { ActionsCellRenderer } from "utils/helpers";

export const PROFILE_TYPE_OPTIONS = [
  { value: "AGENCY", label: "Agency", background: "#439DEE" },
  { value: "BRAND", label: "Brand", background: "#47BC4C" },
];

const CONNECTED_OPTIONS = [
  { value: "CONNECTED", label: "Connected", background: "#47BC4C" },
  { value: "UNCONNECTED", label: "Not Connected", background: "#747474" },
];

const cell = (value: any) => (
  <MDTypography sx={{ fontSize: "14px", fontWeight: 400 }}>{value ?? "—"}</MDTypography>
);

export const makeColumns = (handleAction: (id: string, action: string, row?: any) => void) => [
  {
    Header: "Channel",
    accessor: "channel",
    width: "10%",
    align: "left",
    Cell: ({ value }: any) => cell(value),
  },
  {
    Header: "Channel User",
    accessor: "channelUserId",
    width: "16%",
    align: "left",
    Cell: ({ value }: any) => cell(value),
  },
  {
    Header: "Name",
    accessor: "displayName",
    width: "14%",
    Cell: ({ value }: any) => cell(value),
  },
  {
    Header: "Type",
    accessor: "profileType",
    width: "10%",
    Cell: ({ value }: any) =>
      value ? <StatusChip value={value} options={PROFILE_TYPE_OPTIONS} width={110} /> : cell(null),
  },
  {
    Header: "Connected",
    accessor: "connectedUserId",
    width: "18%",
    Cell: ({ row }: any) => {
      const connected = !!row?.original?.connectedUserId;
      return (
        <MDBox display="flex" flexDirection="column" alignItems="center" gap={0.5}>
          <StatusChip
            value={connected ? "CONNECTED" : "UNCONNECTED"}
            options={CONNECTED_OPTIONS}
            width={140}
          />
          {connected && row?.original?.connectedUser?.email && (
            <MDTypography sx={{ fontSize: "12px" }} color="text">
              {row.original.connectedUser.email}
            </MDTypography>
          )}
        </MDBox>
      );
    },
  },
  {
    Header: "Terms",
    accessor: "termsAcceptedAt",
    width: "7%",
    Cell: ({ value }: any) => (
      <MDTypography sx={{ fontSize: "16px" }} color={value ? "success" : "error"}>
        {value ? "✓" : "✗"}
      </MDTypography>
    ),
  },
  {
    Header: "Created",
    accessor: "createdAt",
    width: "13%",
    Cell: ({ value }: any) => cell(value ? dayjs(value).format("DD MMM YYYY") : "—"),
  },
  {
    Header: "Actions",
    accessor: "actions",
    align: "right",
    width: "12%",
    Cell: ({ row }: any) => {
      const r = row?.original;
      const connected = !!r?.connectedUserId;
      const actions = [
        {
          Icon: <VisibilityOutlinedIcon sx={{ fontSize: 22, color: "#7b809a" }} />,
          onClick: () => handleAction(r.id, "view", r),
        },
        {
          Icon: <ChatBubbleOutlineIcon sx={{ fontSize: 22, color: "#1A73E8" }} />,
          onClick: () => handleAction(r.id, "message", r),
        },
        connected
          ? {
              Icon: <LinkOffIcon sx={{ fontSize: 22, color: "#fb8c00" }} />,
              onClick: () => handleAction(r.id, "disconnect", r),
            }
          : null,
        {
          Icon: <DeleteOutlineIcon sx={{ fontSize: 22, color: "#F44335" }} />,
          onClick: () => handleAction(r.id, "delete", r),
        },
      ];
      return <ActionsCellRenderer actions={actions} />;
    },
  },
];
